/**
 * A composable function used for price formatting.
 * @returns {Object} - An object with the price formatting functions.
 */
export default function useFormatPrice() {
    /**
     * A function to format the price based on the currency and locale
     * @param {Number} amount - The amount to format.
     * @param {String} currency - The currency to format the price.
     * @param {String} locale - The locale to format the price.
     * @returns {String} - The formatted amount.
     */
    function formatPrice(amount, currency, locale) {
        const formattedAmount = Number(amount).toFixed(2)
        let formatted = new Intl.NumberFormat(locale, { style: 'currency', currency }).format(formattedAmount)

        // Custom replacement for Bulgarian BGN format
        if (locale === 'bg' && currency === 'BGN') {
            // Replace the comma with a dot for decimals
            formatted = formatted.replace(',', '.')
            // Replace non-breaking space (usually used as a thousand separator in Bulgarian) with a regular space
            formatted = formatted.replace(/\u00A0/g, ' ')
        }

        return formatted
    }

    return {
        formatPrice
    }
}
